import * as React from 'react';
import LoadingButton from '../loading-button/loading-button.component';
import { LAYOUT_BG_COLOR } from 'utils/styles/colors';
import { SxProps, Box, Typography, Modal } from '@mui/material';

interface IBasicModal {
  btnText: string;
  children: React.ReactNode;
  headline: string;
}

export default function BasicModal({
  btnText,
  headline,
  children,
}: IBasicModal) {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  const style: SxProps = {
    bgcolor: LAYOUT_BG_COLOR,
    boxShadow: 24,
    p: '32px',
    margin:'auto 0px',
    borderRadius: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

  return (
    <Box>
      <LoadingButton sx={{ color: 'yellow' }} onClick={toggleModal}>
        {btnText}
      </LoadingButton>
      <Modal
        open={isOpen}
        onClose={toggleModal}
        sx={{
          display: '-webkit-box',
          '-webkit-box-align': 'center',
          '-webkit-box-pack': 'center',
          overflow: 'auto',
        }}
      >
        <Box sx={style}>
          <Typography
            variant='h2'
            style={{ fontSize: 24, lineHeight: '32px' }}
            sx={{
              width: '470px',
              '@media (max-width: 510px)': {
                width: '100%',
              },
            }}
          >
            {headline}
          </Typography>
          {children}
        </Box>
      </Modal>
    </Box>
  );
}
